import { formatUsd } from 'shared';
import { SurchargeCheck } from '@/components/surcharge-check.js';

interface SurchargeToggleProps {
  description: string;
  basePrice: number;
  optional: boolean;
  selected: boolean;
  onToggle: () => void;
}

export function SurchargeToggle({
  description,
  basePrice,
  optional,
  selected,
  onToggle,
}: SurchargeToggleProps) {
  return (
    <div className="sm-addon">
      <SurchargeCheck
        checked={optional ? selected : true}
        locked={!optional}
        onToggle={onToggle}
        label={optional ? (selected ? `Remove ${description}` : `Add ${description}`) : description}
      />
      <p className="sm-type-body sm-addon-name">
        {description}
        {!optional && <span className="sm-type-eyebrow sm-addon-tag">Included</span>}
      </p>
      {/* Included add-ons are already in the plan price — a "+$200" reads as an extra. */}
      {optional && <span className="sm-type-body-strong sm-tabular">+{formatUsd(basePrice)}</span>}
    </div>
  );
}
